import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css'
import { DBCheckBoxComment } from '_components'

class PatientCareCenterNoteObjectiveMotor extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='obj_motor' name='Motor Planning / Coordination' level={1}>
                 <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPMOVISUAL'
                         className={styles.checkbox}
                         label='Visual motor'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPMOSYMMETRIC'
                         className={styles.checkbox}
                         label='Symmetric movements'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPMOALTERNATING'
                         className={styles.checkbox}
                         label='Alternating movements'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>


                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPMORECIPROCAL'
                         className={styles.checkbox}
                         label='Reciprocal movements'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPMODOMINANT'
                         checkboxStyle={styles.checkbox_size}
                         label='Use of supporting / dominant hand'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPMOCROSSING'
                         className={styles.checkbox}
                         label='Crossing mid-line'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let opno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEPEDS)
        .find(key => (state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        opno: opno
    };
}

const connectedPatientCareCenterNoteObjectiveMotor = connect(mapStateToProps)(PatientCareCenterNoteObjectiveMotor);
export { connectedPatientCareCenterNoteObjectiveMotor as PatientCareCenterNoteObjectiveMotor };